module.exports = __webpack_public_path__ + "img/elsobek.817b02be.svg";